import React from 'react';
import FooterNavBarItem from './FooterNavBarItem';
import FooterSocialLinks from './FooterSocialLinks';
import NavBarItem from './NavBarItem';
import WebIntlProvider from '../ui/i18n/WebIntlProvider';
import {Message} from '@aperza/ui';
import WebMediaQuery from './WebMediaQuery';
import AppService from '../service/AppService';
import AppConfigService from '../service/AppConfigService';
import AppConfig from '../domain/AppConfig';
const appConfig:AppConfig = AppService.appConfig();

export default class Footer extends React.Component {

  render() {

    let enableLangSwitch = false;
    let enableSocialLinks = false;
    if ([AppConfig.APERZA_SEARCH,AppConfig.APERZA_EC].includes(appConfig.serviceType)
      ) {
      enableLangSwitch = true;
    }
    if (appConfig.serviceType == AppConfig.APERZA_NEWS
      ) {
      enableSocialLinks = true;
    }

    return (
      <WebIntlProvider>
        <div className="aperza-footer">
          <div className="aperza-footer-navbar">
            <WebMediaQuery desktopOnly={true}>
              <FooterNavBarItem messageId="navbar.sellers"
                                href="https://www.aperza.com/corp/service/aperza_sellers/"
                                openOnNewTab={true}
                                showExternalLink={true} />
            </WebMediaQuery>
            <WebMediaQuery desktopOnly={true}>
              <FooterNavBarItem messageId="navbar.purchasingAccountFaq"
                                href="https://mp-aperza.zendesk.com/hc/ja"
                                openOnNewTab={true}
                                showExternalLink={true} />
            </WebMediaQuery>
            <FooterNavBarItem messageId="navbar.cancellationPolicy" href="https://www.aperza.com/corp/term/ja/return_cancel.html" />
            {
              enableSocialLinks &&
              <FooterSocialLinks></FooterSocialLinks>
            }
          </div>
          <div className="aperza-footer-menu">
            <WebMediaQuery desktopOnly={true}>
              <div className="aperza-footer-menu-col">
                <div><Message messageId="footer.column.aperza" /></div>
                <NavBarItem title={<Message messageId="footer.aperza" />}
                            className="naviLink-footer-bold"
                            icon="aperza-gray"
                            url={`${appConfig.searchWebHost}${AppConfigService.getLangCode()=='en'?'/en':''}`}
                />
                <NavBarItem title={<Message messageId="footer.catalog" />}
                            className="naviLink-footer-bold"
                            icon="catalog-gray"
                            url={`${appConfig.searchWebHost}${AppConfigService.getLangCode()=='en'?'/en':''}/catalog/`}
                />
                <NavBarItem title={<Message messageId="footer.marketplace" />}
                            className="naviLink-footer-bold"
                            icon="cart-gray"
                            url={`${appConfig.marketplaceWebHost}${AppConfigService.getLangCode()=='en'?'/en':''}`}
                />
                <NavBarItem title={<Message messageId="footer.news" />}
                            className="naviLink-footer-bold"
                            icon="news-gray"
                            openOnNewTab={true}
                            showExternalLink={true}
                            url={`https://news${appConfig.baseDomain}`}
                />
              </div>
            </WebMediaQuery>
            <WebMediaQuery desktopOnly={true}>
              <div className="aperza-footer-menu-col">
                <div><Message messageId="footer.column.media" /></div>
                <NavBarItem title={<Message messageId="footer.automation-news" />}
                            className="naviLink-footer"
                            openOnNewTab={true}
                            showExternalLink={true}
                            url={appConfig.automationNewsUrl}
                />
                <NavBarItem title={<Message messageId="footer.iot" />}
                            className="naviLink-footer"
                            openOnNewTab={true}
                            showExternalLink={true}
                            url={`https://iot.aperza.com/`}
                />
              </div>
            </WebMediaQuery>
            <div className="aperza-footer-menu-col">
              <div><Message messageId="footer.column.about" /></div>
              <NavBarItem title={<Message messageId="footer.info.aperza" />}
                          className="naviLink-footer"
                          openOnNewTab={true}
                          showExternalLink={true}
                          url={`https://www.aperza.com/corp/`}
              />
              <NavBarItem title={<Message messageId="footer.info.privacy" />}
                          className="naviLink-footer"
                          url={`https://www.aperza.com/corp/term/ja/privacy.html`}
              />
              <NavBarItem title={<Message messageId="footer.info.tc" />}
                          className="naviLink-footer"
                          url={`https://www.aperza.com/corp/term/ja/index.html`}
              />
              <NavBarItem title={<Message messageId="footer.info.contactUs" />}
                          className="naviLink-footer"
                          url={`https://www.aperza.com/corp/service/contact/`}
              />
            </div>
            {
              enableLangSwitch &&
              <div className="aperza-footer-menu-col">
                <div><Message messageId="footer.column.language" /></div>
                <NavBarItem title={<Message messageId="lang.ja" />}
                            className="naviLink-footer"
                            disabled={'ja' === AppConfigService.getLangCode()}
                            url={`${AppConfigService.getLangSwitchUrl('ja')}`}
                />
                <NavBarItem title={<Message messageId="lang.en" />}
                            className="naviLink-footer"
                            disabled={'en' === AppConfigService.getLangCode()}
                            url={`${AppConfigService.getLangSwitchUrl('en')}`}
                />
              </div>
            }
          </div>

          <div className="aperza-footer-copyright">
            Copyright © Aperza Inc. All Rights Reserved.
          </div>
        </div>
      </WebIntlProvider>
    )
  }

}
